export enum I18N_NAMESPACES {
  COMMON = "common"
}